import path from 'ramda/es/path'

import { getStateCurrentValue, getStateItems } from 'app/common/ui-components/filter'

import yearFilter from 'app/components/common/reports/filters/year'
import getDefaultPeriod from './defaultPeriod'


const dummyItems = [{ id: 'dummy', title: 'dummy' }]

const periodItems = (state: any) => {
  const yearCurrentIds = getStateCurrentValue('year', state) as Array<string>
  const years = getStateItems(yearFilter, state) as Record<string, { date_start?: string, date_finish?: string }>
  const selectedYearId = yearCurrentIds[0]

  const dateStart = path([selectedYearId, 'date_start'], years) as string | undefined
  const dateFinish = path([selectedYearId, 'date_finish'], years) as string | undefined
  const period = getDefaultPeriod(dateStart, dateFinish)

  return [dummyItems, period]
}

export default periodItems
